import React, { useState } from 'react';
import { api } from '../services/api';
import { nclayerService } from '../services/nclayer';
import { LangSelect, useCabinetLang } from '../i18n';

interface LoginPageProps {
  onSuccess: () => void;
}

export const LoginPage: React.FC<LoginPageProps> = ({ onSuccess }) => {
  const { t } = useCabinetLang();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleEdsLogin = async () => {
    setError('');
    setLoading(true);
    try {
      await api.loginWithNcalayer(async (dataBase64) => {
        const signed = await nclayerService.signAttached(dataBase64);
        if (!signed.success) {
          if (signed.canceledByUser) {
            throw new Error(t.signCanceled);
          }
          throw new Error(signed.error || t.ncalayerError);
        }
        return String(signed.signature || '');
      });
      onSuccess();
    } catch (err) {
      setError(err instanceof Error ? err.message : t.loginError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <div className="login-lang">
            <LangSelect className="lang-switch" />
          </div>
          <h1>
            <span className="login-title-cashalot">Cashalot</span>
            <span className="login-title-edo">ЭДО</span>
          </h1>
          <p>{t.edoSubtitle}</p>
        </div>

        <div className="login-form">
          <p style={{ fontSize: 14, color: '#555', marginBottom: 16 }}>{t.loginEds}</p>
          {error && (
            <div style={{ color: '#c62828', fontSize: 13, marginBottom: 12 }}>{error}</div>
          )}
          <button
            type="button"
            className="btn-login"
            disabled={loading}
            onClick={() => void handleEdsLogin()}
          >
            {loading ? t.waitingEds : t.chooseCert}
          </button>
        </div>

        <p className="login-back-link">
          <a href="https://ncl.pki.gov.kz/" target="_blank" rel="noopener noreferrer">
            {t.downloadNca}
          </a>
        </p>
      </div>
    </div>
  );
};
